module.exports = {
  NEW_TO_OLD: 1,
  OLD_TO_NEW: 2,
  ASC: 3,
  DESC: 4,
  CHEAPEAST: 5,
  MOST_EXPENSIVE: 6
}
